let LODOP = getLodop();
// var idcard1 = require('@/assets/images/idcard-index.png')
// var idcard2 = require("@/assets/images/idcard.png");
// var idcard1 = 'http://123.131.74.135:9000/yyzz/zheng.png'
// var idcard2 = 'http://123.131.74.135:9000/yyzz/fan.png'
var idcard1 = 'http://47.92.198.27/zheng.png'
var idcard2 = 'http://47.92.198.27/fan.png'
var P_ID = "", TaskID1, TaskID2, t, waiting = false, c = 0, loop = 0; //声明为全局变量 
var lodop = {
  zzPrint: (url) => {
    LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "210mm", "297mm", "证照打印");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4");
    LODOP.ADD_PRINT_IMAGE("0", "0", "200mm", "297mm", url);
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
    // LODOP.PRINT_DESIGN();
    LODOP.SET_PRINTER_INDEX("jbxx");
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("Lenovo-LJ2405");
    // LODOP.SET_PRINTER_INDEX("HP ColorLaserJet M253-M254 PCL 6 (V3)");
    LODOP.PRINT();
  },
  yyzzPrint: (url) => {
    LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "297mm", "220mm", "证照打印");
    LODOP.SET_PRINT_PAGESIZE(2, 0, 0, "A4");
    // LODOP.ADD_PRINT_IMAGE("0", "0", "297mm", "210mm", url);
    LODOP.ADD_PRINT_IMAGE("0", "0", "297mm", "210mm", "data:image/png;base64," + demoDownloadPDF(url));
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
    // LODOP.PRINT_DESIGN();
    LODOP.SET_PRINTER_INDEX("jbxx");
    LODOP.PRINT();
  },
  tablePrint: (html, Name) => {
    LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "210mm", "297mm", "办事指南");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4");
    // LODOP.ADD_PRINT_TEXT("15mm","0mm","210mm","14mm",Name);
    // LODOP.SET_PRINT_STYLEA(0,"FontName","黑体");
    // LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    // LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
    // LODOP.SET_PRINT_STYLEA(0,"Bold",1);
    // LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑简");

    // LODOP.ADD_PRINT_TABLE("27.94mm", "15mm", "180mm", "297mm", html);
    LODOP.ADD_PRINT_URL("5mm", "15mm", "210mm", "297mm", html);
    // LODOP.ADD_PRINT_PDF(0,0,"100%","100%",'http://123.131.74.135:9000/yyzz/ss_20240711152740.pdf');
    // LODOP.PRINT_DESIGN();
    LODOP.SET_PRINTER_INDEX("jbxx");
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("Lenovo-LJ2405");
    // LODOP.SET_PRINTER_INDEX("HP ColorLaserJet M253-M254 PCL 6 (V3)");
    LODOP.PRINT();
  },
  idcardPrint: (data, avatar) => {
    LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "210mm", "297mm", "身份证打印");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4");
    LODOP.ADD_PRINT_IMAGE("24.08mm", "39.16mm", "124.09mm", "82.29mm", `<img src=${idcard1}>`);
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
    LODOP.ADD_PRINT_IMAGE("122.98mm", "39.16mm", "124.09mm", "82.29mm", `<img src=${idcard2}>`);
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
    LODOP.ADD_PRINT_TEXT("35.72mm", "62.18mm", "26.46mm", "6.61mm", `${data.Name}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
    LODOP.ADD_PRINT_TEXT("45.51mm", "62.18mm", "26.46mm", "6.61mm", `${data.Sex}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT("45.51mm", "87.58mm", "29.37mm", "10.58mm", `${data.Nation}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT("54.77mm", "62.18mm", "14.02mm", "6.61mm", `${data.Birthday.slice(0, 4)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_TEXT("54.77mm", "80.17mm", "8.73mm", "6.61mm", `${data.Birthday.slice(4, 6)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_TEXT("54.77mm", "91.02mm", "9mm", "6.61mm", `${data.Birthday.slice(6, 8)}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_TEXT("65.35mm", "62.18mm", "53.98mm", "22.75mm", `${data.Address}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT("90.22mm", "82.29mm", "70.11mm", "6.61mm", `${data.IDNumber}`);
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", "0.79mm");
    LODOP.ADD_PRINT_TEXT("179.92mm", "87.84mm", "66.15mm", "6.61mm", `${data.IDIssued}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT("189.18mm", "87.84mm", "66.15mm", "6.61mm", `${data.periodTime}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    // LODOP.ADD_PRINT_URL("35.98mm","118.8mm","36.25mm","48.15mm",`${data.Base64Photo}`);
    LODOP.ADD_PRINT_IMAGE("37.04mm", "119.59mm", "37.31mm", "45.77mm", `${avatar}`);
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
    //  LODOP.PRINT_DESIGN();
    LODOP.SET_PRINTER_INDEX("jbxx");
    // LODOP.SET_PRINTER_INDEX("HP520002");
    // LODOP.SET_PRINTER_INDEX("Lenovo-LJ2405");
    // LODOP.SET_PRINTER_INDEX("HP ColorLaserJet M253-M254 PCL 6 (V3)");
    LODOP.PRINT();
  },
  pdfPrint: (url, count, callback) => {
    // console.log('count', count);
    LODOP = getLodop();
    LODOP.PRINT_INITA("19mm", "0mm", "210mm", "297mm", "证照打印");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4");
    // LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", demoDownloadPDF(url));
    LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", url);
    // LODOP.PRINT_DESIGN();
    // LODOP.SET_PRINTER_INDEX("Lenovo-LJ2405");
    // LODOP.SET_PRINTER_INDEX("HP ColorLaserJet M253-M254 PCL 6 (V3)");
    LODOP.SET_PRINTER_INDEX("jbxx");
    // LODOP.SET_PRINT_MODE("PRINT_END_PAGE", count);
    // getPrintPages(callback)
    LODOP.PRINT();

  },

  testPrint: (url, count, callback) => {
    LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "210mm", "297mm", "证照打印");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4");
    LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", url);
    // LODOP.SET_PRINTER_INDEX("Lenovo-LJ2405");
    LODOP.SET_PRINTER_INDEX("HP ColorLaserJet M253-M254 PCL 6 (V3)");
    LODOP.SET_PRINT_MODE("PRINT_END_PAGE", count);
    getPrintPages(callback)
    LODOP.PRINT();
  },
  zitiPrint: () => {
    LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0mm", "210mm", "297mm", "字体打印测试");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, "A4");
    LODOP.ADD_PRINT_TEXT("88mm", "39mm", "60mm", "30mm", "统一社会信用代码");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 18);
    // LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
    LODOP.ADD_PRINT_TEXT("8.47mm", "14.02mm", "112.71mm", "13.23mm", "营业执照");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
    LODOP.ADD_PRINT_TEXT("22.49mm", "14.02mm", "112.71mm", "13.23mm", "营业执照");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪书宋二简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
    LODOP.ADD_PRINT_TEXT("36.51mm", "14.02mm", "112.71mm", "13.23mm", "营业执照");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑 简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
    LODOP.ADD_PRINT_TEXT("47.36mm", "14.02mm", "112.71mm", "13.23mm", "营业执照");
    LODOP.SET_PRINT_STYLEA(0, "FontName", "汉仪中黑简");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
    LODOP.PRINT_DESIGN();
    // LODOP.PRINT();
  },
  // 事项申报打印
  sbxbPrint: (data, qrcode) => {
    LODOP = getLodop();
    LODOP.PRINT_INITA("0mm", "0.2mm", "80.01mm", "120.01mm", "叫号凭条");

    LODOP.ADD_PRINT_TEXT("12.17mm", "-1.06mm", "80.7mm", "8.47mm", "自助服务受理通知单");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 15);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_TEXT("23.55mm", "4.76mm", "57.94mm", "6.61mm", `尊敬的${data.name}：`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.ADD_PRINT_TEXT("30.69mm", "4.76mm", "70.91mm", "12.44mm", `    关于${data.title}的业务您已申报成功`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.ADD_PRINT_TEXT("44.33mm", "4.76mm", "70.91mm", "6.61mm", `    申办编号：${data.lsh}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.ADD_PRINT_TEXT("49.89mm", "4.76mm", "70.91mm", "6.61mm", `    查询密码：${data.pswd}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.ADD_PRINT_TEXT("57.3mm", "3.44mm", "59.27mm", "6.35mm", "    进度查询");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_TEXT("63.65mm", "3.44mm", "62.97mm", "11.38mm", "    手机扫描二维码查询办件进度");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT("75.03mm", "8.73mm", "70.91mm", "5.82mm", "注：业务人员预审通过后才能查询到办件进度");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
    LODOP.ADD_PRINT_IMAGE("82.01mm", "21.25mm", "31.75mm", "31.75mm", qrcode);
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
    // LODOP.PRINT_DESIGN();
    // LODOP.SET_PRINTER_INDEX("POS80");
    LODOP.SET_PRINTER_INDEX("xiaopiao");
    LODOP.PRINT();
  },
}
// 获取打印页数
function getPrintPages(callback) {
  LODOP.SET_PRINT_MODE("CATCH_PRINT_STATUS", true);
  LODOP.On_Return = function (TaskID, ValueIndex) {
    LODOP.On_Return = function (TaskID, Pages) {
      // console.log('页数', Pages);
      callback(Pages)
    };
    var strResult = LODOP.GET_VALUE("PRINT_STATUS_TOTAL_PAGES", ValueIndex);
  };
}

// function getStatusValue(ValueType, ValueIndex) {
//   LODOP.On_Return = function (TaskID, Value) {
//     console.log('页数', Value);
//     };
// 		var strResult=LODOP.GET_VALUE(ValueType,ValueIndex);
// };
function demoDownloadPDF(url) {
  if (!(/^https?:/i.test(url))) return;
  if (window.XMLHttpRequest) var xhr = new XMLHttpRequest(); else var xhr = new ActiveXObject("MSXML2.XMLHTTP");
  xhr.open('GET', url, false); //同步方式
  if (xhr.overrideMimeType)
    try {
      xhr.responseType = 'arraybuffer';
      var arrybuffer = true;
    } catch (err) {
      xhr.overrideMimeType('text/plain; charset=x-user-defined');
    }
  xhr.send(null);
  var data = xhr.response || xhr.responseBody;
  if (typeof Uint8Array !== 'undefined') {
    if (arrybuffer) var dataArray = new Uint8Array(data); else {
      var dataArray = new Uint8Array(data.length);
      for (var i = 0; i < dataArray.length; i++) { dataArray[i] = data.charCodeAt(i); }
    }
  } else
    var dataArray = VBS_BinaryToArray(data).toArray(); //兼容IE低版本
  return demoGetBASE64(dataArray);
}
function demoGetBASE64(dataArray) {
  var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var strData = "";
  for (var i = 0, ii = dataArray.length; i < ii; i += 3) {
    if (isNaN(dataArray[i])) break;
    var b1 = dataArray[i] & 0xFF, b2 = dataArray[i + 1] & 0xFF, b3 = dataArray[i + 2] & 0xFF;
    var d1 = b1 >> 2, d2 = ((b1 & 3) << 4) | (b2 >> 4);
    var d3 = i + 1 < ii ? ((b2 & 0xF) << 2) | (b3 >> 6) : 64;
    var d4 = i + 2 < ii ? (b3 & 0x3F) : 64;
    strData += digits.substring(d1, d1 + 1) + digits.substring(d2, d2 + 1) + digits.substring(d3, d3 + 1) + digits.substring(d4, d4 + 1);
  }
  return strData;
}
export default lodop;
